<template>
    <answers ref="answers"
             code_question_group="GQ19"
             danger_code="MCAL04"
    />
</template>

<script>
import answers from '../../../components/answers.vue';

export default {
    name: 'index',
    components: {
        answers
    }
};
</script>
